<div class="min-h-screen py-8">
  <div class="max-w-6xl mx-auto px-4">
    <!-- Header -->
    <div class="text-center mb-8">
      <h1 class="text-3xl font-bold text-gray-900 mb-2">Gestión de Contactos</h1>
      <p class="text-gray-600">Administra y consulta la información de tus clientes de manera eficiente</p>
    </div>

    <!-- Formulario de Búsqueda de Cliente -->
    <div *ngIf="canSearch" class="bg-white rounded-lg shadow-md p-6 mb-8">
      <div class="flex items-center mb-4">
        <div class="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center mr-3 bg-blue-100 text-blue-600">
          <i class="fas fa-search text-xl"></i>
        </div>
        <div>
          <h2 class="text-xl font-semibold text-gray-900">Buscar Cliente</h2>
          <p class="text-sm text-gray-600">Encuentra rápidamente un cliente específico por número de cédula</p>
        </div>
      </div>

      <!-- Formulario -->
      <form [formGroup]="searchForm" (ngSubmit)="searchClient()" class="space-y-6">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <!-- Código -->
          <div class="md:col-span-1">
            <label for="code_identity" class="block text-sm font-medium text-gray-700 mb-2">
              Código
            </label>
            <select
              id="code_identity"
              formControlName="code_identity"
              class="w-full px-4 py-3 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
              [class.border-red-500]="searchForm.get('code_identity')?.invalid && searchForm.get('code_identity')?.touched">
              <option value="">Seleccione</option>
              <option *ngFor="let item of code_identity" [value]="item.code">{{item.name}}</option>
            </select>
            <div *ngIf="searchForm.get('code_identity')?.invalid && searchForm.get('code_identity')?.touched" class="text-red-500 text-xs mt-1">
              Campo requerido
            </div>
          </div>

          <!-- Número de Documento -->
          <div class="md:col-span-2">
            <label for="identity" class="block text-sm font-medium text-gray-700 mb-2">
              Número de Cédula
            </label>
            <input
              type="text"
              id="identity"
              formControlName="identity"
              placeholder="Ingrese el número de cédula"
              class="w-full px-4 py-3 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
              [class.border-red-500]="searchForm.get('identity')?.invalid && searchForm.get('identity')?.touched">
            <div *ngIf="searchForm.get('identity')?.invalid && searchForm.get('identity')?.touched" class="text-red-500 text-xs mt-1">
              <span *ngIf="searchForm.get('identity')?.errors?.['required']">Campo requerido</span>
              <span *ngIf="searchForm.get('identity')?.errors?.['minlength']">Mínimo 6 caracteres</span>
              <span *ngIf="searchForm.get('identity')?.errors?.['maxlength']">Máximo 8 caracteres</span>
            </div>
          </div>
        </div>

        <!-- Botones -->
        <div class="flex justify-end space-x-3">
          <button
            type="button"
            (click)="clearSearch()"
            class="px-6 py-3 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors">
            <i class="fas fa-times mr-2"></i>
            Limpiar
          </button>
          <button
            type="submit"
            [disabled]="!searchForm.valid || searchLoading"
            class="px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            <span *ngIf="searchLoading" class="inline-flex items-center">
              <i class="fas fa-spinner fa-spin mr-2"></i>
              Consultando...
            </span>
            <span *ngIf="!searchLoading" class="inline-flex items-center">
              <i class="fas fa-search mr-2"></i>
              Consultar
            </span>
          </button>
        </div>
      </form>

      <!-- Mensaje de cliente no encontrado -->
      <div *ngIf="clientNotFound" class="mt-4 p-4 bg-red-50 border border-red-200 rounded-md">
        <div class="flex items-center">
          <i class="fas fa-exclamation-triangle text-red-500 mr-2"></i>
          <span class="text-red-700">Cliente no encontrado. Verifique los datos ingresados.</span>
        </div>
      </div>
    </div>

    <!-- Opciones de Gestión -->
    <div class="space-y-3">

      <ng-container *ngFor="let option of contactOptions">
        <ng-container *ngIf="hasPermission(option)">
          <a [attr.data-rbac-permiso]="option.rbacPermissions?.join(' ')" *ngIf="option.route" [routerLink]="[option.route]" class="block bg-white rounded-lg border border-gray-200 hover:border-blue-500 hover:shadow-md transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-400">
            <div class="flex items-center p-4">
              <div class="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center mr-4 bg-blue-100 text-blue-600">
                <i [class]="option.icon + ' text-2xl'"></i>
              </div>
              <div class="flex-1 min-w-0">
                <h3 class="text-lg font-semibold text-gray-900">{{ option.title }}</h3>
                <p class="text-sm text-gray-600">{{ option.description }}</p>
              </div>
              <div class="flex-shrink-0 ml-4">
                <i class="fas fa-chevron-right text-gray-400"></i>
              </div>
            </div>
          </a>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>